module.exports = __webpack_public_path__ + "static/img/driving_main.b8ccabd.png";